<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="线下支付" left-arrow fixed  @click-left="back" />
        <van-row>
          <van-col span="24">
              <div class="jump-order-body">
                <div class="jump-order-body-whd">
                   <i class="iconfont icon-hezuowoshou"></i>
                </div>
                <div class="jump-order-body-foot">
                    <p>订单编号：<span>{{orderId}}</span></p>
                    <p>订单金额：<span>{{orderPrice}}元</span></p>
                     <!-- <div v-if="integralMsgShow">
                       <p>预计可获得积分：<span>{{getIntegral}}</span></p>
                        <p>当前持有积分：<span>{{userIntegral}}</span></p>
                        <p>可兑换商品：<span>{{availableQuantity}}</span>种<a style="color:red;margin-left:20px" href="#/integral/home">去兑换>></a></p>
                      </div> -->
                    <p v-if="pointAmount>0">积分抵扣金额：<span>{{pointAmount}}</span></p>
                </div>
                 <div class="jump-order-body-foot-hd">
                     <van-field label="交易号码" v-model="bankDealNum" />
                      <van-uploader :after-read="onRead" style="display:block">
                          <van-field label="支付凭证" v-model="accessoryText" readonly placeholder="请选择凭证" />
                      </van-uploader>
                     <img class="id-img" v-if="imgUrl!=''" :src="imgUrl" ref="idImg"/>
                     <!--<van-image-->
                             <!--class="id-img"-->
                             <!--:src="imgUrl"-->
                     <!--/>-->
                     <van-field  type="textarea" label="备注信息" v-model="remarks" />
                    <van-button size="large" @click="pay">确认提交订单</van-button>
                </div>
            </div>
          </van-col>
          <van-col span="4"></van-col>
        </van-row>
    </div>
</template>
<script>
import { NavBar, Button, Row, Col, Field, Uploader  } from "vant";
export default {
  name: "orderpayoffline",
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Uploader.name]: Uploader
  },
  data() {
    return {
      orderIds:'',
      orderId:0,//显示
      orderPrice:0,
      bankDealNum:'',
      remarks:'',
      accessoryId:'',
      imgUrl:'',
      accessoryText:'',
      uploadCertificateUrl:'',
      id:'',
      orders:'',
      pointAmount:0,

      getIntegral:0,//预计可获得积分
      availableQuantity:0,//可兑换
      userIntegral:0,//当前积分
      integralMsgShow:false
    };
  },
  methods: {
    back() {
        location.href = "#/cart";
    },
    onRead(file, detail) {
      let that = this;
      let fileFormData = new FormData();
      fileFormData.append('files', file.file)
      that.$api.post(that.uploadCertificateUrl,fileFormData,successRes=>{
        if(successRes.result){
            that.accessoryId = successRes.data.id;
            that.imgUrl = successRes.data.imgUrl;
            that.$toast('上传成功!');
        }else{
            that.$toast('上传失败!');
        }
      })
    },
    pay(){
      let that = this;
      that.$api.post(that.jumuc.pay.order,
        {
            paytype:'underPay',
            orderId:that.id,
            bankDealNum	:that.bankDealNum	,
            orders:that.orders,
            payRemarks:that.remarks,
            accessoryId:that.accessoryId
        },
        successResPay=>{
            if(successResPay.success){
                 location.href = "#/order/success?orderId="+successResPay.data.orderId+
                 "&orderPrice="+successResPay.data.totalPrice+"&getIntegral="
                 +successResPay.data.getIntegral+"&availableQuantity="+successResPay.data.availableQuantity
                 +"&userIntegral="+successResPay.data.userIntegral+"&integralMsgShow="+successResPay.data.integralMsgShow;
            }else{
              that.$toast(successResPay.msg);
            }
        })
    }
  },
  mounted(){
    this.id =  this.$route.query.id;
    this.orderIds = this.$route.query.orderIds;
    this.orderId = this.$route.query.orderId;
    this.orderPrice = this.$route.query.orderPrice;
    this.uploadCertificateUrl = this.$route.query.uploadCertificateUrl;
    this.orders = this.$route.query.orders;
    this.pointAmount = this.$route.query.pointAmount;

    this.getIntegral = this.$route.query.getIntegral;
    this.availableQuantity = this.$route.query.availableQuantity;
    this.userIntegral = this.$route.query.userIntegral;
    this.integralMsgShow=this.$route.query.integralMsgShow=='true'?true:false;

  }
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;
.van-uploader{
  width: 100%;
}
.jump-order {
  padding-top: 50px;

  &-body {
    padding-top: 40px;
    &-whd {
      text-align: center;
      i {
        color: #1989fa;
        font-size: 60px;
      }
      p {
        padding: 20px 0;
      }
    }
    &-foot {
      padding: 0 60px;
      p {
        padding-left: 15px;
        margin-bottom: 10px;
        span {
          color: red;
        }
      }
    }
    &-foot-hd {
      padding: 0 20px;
      button {
        background-color: @bule-thame;
        color: white;
        font-weight: 700;
        border-radius: 50px;
        margin: 25px 0 10px;
      }
      .van-field__label {
        color: @bule-thame;
      }
    }
  }
    .id-img{
        width: 95%;
        height: 180px;
    }
}
</style>


